import { render, staticRenderFns } from "./CompanyListViewItemCard.vue?vue&type=template&id=4fd61b61&scoped=true&"
import script from "./CompanyListViewItemCard.vue?vue&type=script&lang=js&"
export * from "./CompanyListViewItemCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyListViewItemCard.vue?vue&type=style&index=0&id=4fd61b61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd61b61",
  null
  
)

export default component.exports